import { useState } from "react";

import './Btn.css';

interface Props {
    type?: string;
    title: string;
    OpenFuncition?: () => void;
}

export default function Comp_Btn(props: Props) {

    return (
        props.type ?
            <div className={ `Comp_Btn Comp_Btn_Text ${ props.type }` } onClick={ ()=>{ props.OpenFuncition && props.OpenFuncition() } }>
                { props.title }
            </div>
        :
        <button type="submit" className="Comp_Btn">
            { props.title }
        </button>
    );
}
